import { createSlice } from '@reduxjs/toolkit';
import { PermissionDetailStateType } from 'src/types/permissionDetail';

const initialState: PermissionDetailStateType = {
    data: null,
    loading: false,
    deleted: false,
    error: false,
};
export const permissionDetailSlice = createSlice({
    name: 'permissionDetail',
    initialState,
    reducers: {
        getPermissionDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getPermissionDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        getPermissionDetailFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        createPermissionDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        createPermissionDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        createPermissionDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        updatePermissionDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        updatePermissionDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        updatePermissionDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        deletePermissionFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        deletePermissionFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.deleted = true;
            state.loading = false;
        },
        deletePermissionFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        clearPermissionDetail: () => initialState,
    },
});

export const {
    getPermissionDetailFetch,
    getPermissionDetailFetchSuccess,
    getPermissionDetailFetchFailure,
    createPermissionDetailFetch,
    createPermissionDetailFetchSuccess,
    createPermissionDetailFetchFailure,
    updatePermissionDetailFetch,
    updatePermissionDetailFetchSuccess,
    updatePermissionDetailFetchFailure,
    deletePermissionFetch,
    deletePermissionFetchSuccess,
    deletePermissionFetchFailure,
    clearPermissionDetail,
} = permissionDetailSlice.actions;

export default permissionDetailSlice.reducer;
